













































































import { ValidationObserver } from 'vee-validate';
import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator';

import ModelSetter from "../../Mixins/ModelSetter";
import { confirmEmail, sendEmailConfirmCode } from "../../logic/auth/logic";
import { successNotificationWrapper } from "../../logic/helpers/NotificationService";
import TextInput from "../Pi/fields/TextInput/TextInput.vue";

enum SetEmailStepsEnum {
  Email,
  Code,
}

@Component({
  data() {
    return {
      SetEmailStepsEnum
    }
  },
  components: {
    TextInput,
    ValidationObserver
  }
})
export default class SetUserEmail extends Mixins(ModelSetter) {
  @VModel({ type: Boolean }) isModalOpen!: boolean

  @Prop({ type: Boolean }) hasEmail!: boolean

  @Prop({ type: String }) currentEmail!: string | null

  @Emit()
  emailConfirmed() {
    return null
  }

  model = this.defaultModel()

  currentStep: SetEmailStepsEnum = SetEmailStepsEnum.Email

  get modalTitle() {
    if (this.hasEmail) {
      return this.$t('email_modal_change_title').toString()
    } else {
      return this.$t('email_modal_set_title').toString()
    }
  }

  get okText() {
    if (this.currentStep === SetEmailStepsEnum.Email) {
      return this.$t('next_title').toString()
    } else if (this.currentStep === SetEmailStepsEnum.Code) {
      return this.$t('accept').toString()
    } else {
      return ''
    }
  }

  defaultModel() {
    return {
      email: '',
      code: ''
    }
  }

  afterModalClose() {
    this.model = this.defaultModel()
    this.currentStep = SetEmailStepsEnum.Email
  }

  submitStep() {
    if (this.currentStep === SetEmailStepsEnum.Email) {
      this.sendEmailConfirmCodeVm(this.model.email)
    } else {
      this.confirmEmailVm(this.model.code)
    }
  }

  sendEmailConfirmCodeVm(email: string) {
    sendEmailConfirmCode(email)
      .then(res => {
        if (res) {
          this.currentStep = SetEmailStepsEnum.Code
        }
      })
  }

  confirmEmailVm(code: string) {
    confirmEmail(code)
      .then(res => {
        if (res) {
          successNotificationWrapper(this.$t('email_changed_success').toString(), '')

          this.isModalOpen = false

          this.emailConfirmed()
        }
      })
  }
}
